angular
  .module('contributor')

  .controller('ContributorHeaderCtrl', [
    '$scope',
    '$filter',
    '$stateParams',
    '$modal',
    'Confirm',
    'Dialog',
    'UpdateTasksCountersCrud',
    'UpdateContributorsLastTaskCrud',
    'UpdateContributorsRatingsCrud',

    function(
      $scope,
      $filter,
      $stateParams,
      $modal,
      Confirm,
      Dialog,
      UpdateTasksCountersCrud,
      UpdateContributorsLastTaskCrud,
      UpdateContributorsRatingsCrud
    ) {
      const confirm = new Confirm();

      $scope.addingToTask =
        $stateParams.fromState ===
          'root.app.simple.quote.projects.detail.tasks' ||
        $stateParams.fromState ===
          'root.app.simple.order.projects.detail.tasks';

      $scope.selectAllContributors = () => {
        $scope.$parent.$broadcast('selectAllContributors');
      };

      $scope.sendUpdateProfileRequests = () => {
        $scope.$parent.$broadcast('sendUpdateProfileRequests');
      };

      $scope.download = () => {
        confirm.info($filter('translate')('DOWNLOAD_REQUEST')).then(() => {
          $scope.$parent.$broadcast('downloadContributors');
        });
      };

      $scope.downloadSpecializations = () => {
        confirm.info($filter('translate')('DOWNLOAD_REQUEST')).then(() => {
          $scope.$parent.$broadcast('downloadSpecializations');
        });
      };

      $scope.downloadSpecializationsTotals = () => {
        confirm.info($filter('translate')('DOWNLOAD_REQUEST')).then(() => {
          $scope.$parent.$broadcast('downloadSpecializationsTotals');
        });
      };

      $scope.addContributorsToTask = () => {
        $scope.$parent.$broadcast('addContributorsToTask');
      };

      $scope.export = () => {
        confirm.info($filter('translate')('DOWNLOAD_REQUEST')).then(() => {
          $scope.$parent.$broadcast('exportContributorsToJson');
        });
      };

      $scope.$on('multiContributorsSelect', (ev, multiContributorsSelect) => {
        $scope.multiContributorsSelect = multiContributorsSelect;
      });

      $scope.updateTasksCounters = () => {
        const dialog = new Dialog();
        Promise.all([
          new UpdateTasksCountersCrud().save(),
          new UpdateContributorsLastTaskCrud().save(),
          new UpdateContributorsRatingsCrud().save()
        ])
          .then(() => {
            dialog.info(
              $filter('translate')('contributors.UPDATE_TASKS_DONE_MSG')
            );
          })
          .catch(() => {
            dialog.error($filter('translate')('error.RECEIVE_ERR'));
          });
      };
    }
  ]);
